import axios from 'axios';

export const updateAccount = async (user) => {
  const url = `${SERVICE_URL}/api/v1/admin/account`;
  return axios.put(url, user).then((response) => response.data);
};

export const getAccounts = async () => {
  const url = `${SERVICE_URL}/api/v1/admin/accounts`;
  return axios.get(url).then((response) => response.data);
};

export const getPaginatedAccounts = async (search) => {
  const url = `${SERVICE_URL}/api/v1/admin/accounts/paginated${search}`;
  return axios.get(url).then((response) => response.data);
};

export const postAccountIds = async (userIds, search) => {
  const idQuery = { ids: userIds };
  const url = `${SERVICE_URL}/api/v1/admin/accounts/by_ids${search}`;
  return axios.post(url, idQuery).then((response) => response.data);
};
